<template>
	<div class="chatlist">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<!-- @click="back" -->
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">系统消息</p>
				</div>
			</div>
		</van-sticky>
		<!-- 消息列表 -->
		<div class="message_list" id="chatlist">
			<div class="news_list">
				<div class="ul_parents" v-for="item in systemList">
					<p class="message_times">
						<span>{{item.createtime}}</span>
					</p>
					<ul class="news_part left">
						<img src="../../assets/img/myicon/myimg.png" alt="">
						<li>
							<!-- <p class="name">{{item.title}}</p> -->
							<p class="news_info">{{item.content}}</p>
						</li>
					</ul>
				</div>
			</div>
		</div>
		
		<!-- loading -->
		<Loading v-show="isLoading"></Loading>
	</div>
</template>

<script>
	export default{
		data(){
			return {
				systemList:[], //系统消息
				isLoading: false, //loading显示
			}
		},
		mounted() {
			this.scrollToBottom();
		},
		created(){
			this.get_system(); //获取系统消息
			this.scrollToBottom(); //滚动条置于最底部
		},
		methods: {
			back (){
				this.$router.go(-1);
			},
			scrollToBottom: function () { //页面加载完成 将滚动条移动至最低部，显示最新消息
			  this.$nextTick(() => {
				  setTimeout(function(){
					  var heighttop = $("#chatlist")[0].scrollHeight;
					  $("#chatlist").scrollTop(heighttop)
				  })
			  })
			},
			get_system() { //获取系统消息
				var _t = this;
				_t.isLoading = true;
				_t.$axios.post(`${_t.$api.service_msg_list}`).then((response) => {
					if(response.data.code == 1){
						var resdata = response.data.data;
						for(var i = 0; i < resdata.length; i++){
							resdata[i].createtime = _t.formatDateTime(resdata[i].createtime);
							resdata[i].content = resdata[i].content.replace(/<[^>]+>/g, "");
						}
						_t.systemList = resdata;
						_t.scrollToBottom(); //滚动条置于最底部
					}else{
						_t.$toast(response.data.msg);
					}
					
					_t.isLoading = false;
				}).catch(() => {console.log('promise catch err');_t.isLoading = false;});
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) + " " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2);
			
				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
		}
	}
</script>

<style scoped>
	/* 头部 */
	.headerBox {
		height: 160px;
		/* background-color: ; */
        /* background-image: linear-gradient(#ff6ea0, #ff4081); */
		display: flex;
		background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
		background-size: 100%;
		border-bottom: 1px solid #f0f0f0;
	}
	.headerQuery {
		margin-top: 80px;
		padding: 0 16px;
		position: relative;
		display: flex;
		width: 100%;
		height: 80px;
		line-height: 80px;
		color: #000;
	}
	.arrImg	img {
		width: 40px;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 0px;
	}
	.header_titile {
		flex: 1;
		text-align: center;
		font-size: 34px;
		/*px*/
	}
	/* 消息部分 */
	.message_list{
		height:90vh;
		background: #f9f9f9;
		padding:0px 20px 50px 20px;
		box-sizing: border-box;
		overflow-y: auto;
	}
	.news_list{
		overflow-y: auto;
	}
	.news_list .message_times{
		text-align: center;
		padding:40px 0 5px;
	}
	.news_list .message_times span{
		font-size: 22px;
		background: #E0E0E0;
		color: #333;
		display: inline-block;
		padding:5px 15px 3px;
		border-radius: 25px;
	}
	.news_list .news_part{
		display: flex;
		flex-direction: row;
		margin-top:20px;
	}
	.news_list .news_part img{
		width:75px;
		height:75px;
		border-radius: 50%;
	}
	.news_list .news_part li{
		width:87%;
	}
	.news_list .left li{
		margin-left: 15px;
	}
	.news_list .left li .name{
		font-size: 20px;
	}
	.news_list .left li .news_info{
		font-size: 24px;
		display: inline-block;
		background: #fff;
		padding:10px 16px;
		box-sizing: border-box;
		max-width:100%;
		margin-top:10px;
		border-radius: 4px;
		position: relative;
		word-break: break-all;
		line-height: 38px;
	}
	.news_list .left li .news_info::before{
		content: "";
		position: absolute;
		left: -17px;
		top: 5px;
		height: 0;
		width: 0;
		overflow: hidden;
		font-size: 0;
		line-height: 0;
		border-color: transparent #fff transparent transparent ;
		border-style: solid;
		border-width: 10px;
	}
</style>
